unit f_comunicazioni;

{$mode objfpc}

interface

uses
  Classes, SysUtils, strutils, js, web, un_widget, un_tquery, w_table,
  w_edit, w_label, DB, un_user, DateUtils;

type
  TVisibilita = (visDateErrate, visNessunRecord, visLimiteRecord, visCiSonoRecord, visCaricamentoInCorso);

const
  limiteRecord = 300;
  msgLimiteRecord = 'Sono riportati solo gli ultimi 300 prodotti';
  msgDateErrate = 'Correggi le date corrette per visualizzare gli prodotti';
  msgNessunRecord = 'Nessun record da visualizzare';
  msgCaricamentoInCorso = 'Caricamento record in corso...';

type
  { TFrmComunicazioni }

  TFrmComunicazioni = class(TWidget)
    procedure AfterRender; override;
  private
    whereDate: String;
    dt1str, dt2str: String;
    function DateOk: Boolean;
    procedure ShowComunicazioni; async;
    procedure QryVolontariOnFilterRecord(DataSet: TDataSet; var Accept: Boolean);
    procedure RefreshFiltro;
    procedure SetLabel(lbl: TWLabel; value: String);
    procedure ImpostaVisibilita(visibilita: TVisibilita);
  published
    procedure filtro_change;
    procedure filtro_input;
    procedure lblHeader_click; async;
    procedure data1_change;
    procedure data2_change;
    filtro: TWEdit;
    pnltab1: TJSHTMLElement;
    QryComunicazioni: TQuery;
    tab1: TWTable;
    labelTop: TWLabel;
    labelBottom: TWLabel;
    pnlTabella: TJSHTMLElement;
    data1: TJSHTMLInputElement;
    data2: TJSHTMLInputElement;
  end;

implementation

{$R *.html}

{ TFrmComunicazioni }

procedure TFrmComunicazioni.AfterRender;
var
  dataminfiltro : String;
  datamaxfiltro : String;
begin
  dataminfiltro := DateToStr(date);
  datamaxfiltro := DateToStr(date + 3650);

  data1.value := Copy(dataminfiltro,7,4) +'-'+
         Copy(dataminfiltro,4,2) +'-'+
         Copy(dataminfiltro,1,2);
  data2.value := Copy(datamaxfiltro,7,4) +'-'+
         Copy(datamaxfiltro,4,2) +'-'+
         Copy(datamaxfiltro,1,2);
  QryComunicazioni.OnFilterRecord := @QryVolontariOnFilterRecord;

  filtro.placeholder := 'Ricerca note...';
  filtro.seleziona1.Visible := false;

  labelTop.header.innerHTML := '<br><br>';
  labelTop.labelbody.style.cssText := 'background-color: yellow; text-align: center; border-color: red; font-size: 18px; font-weight: bold; border-style: solid;';
  labelTop.footer.innerHTML := '<br><br>';

  labelBottom.labelbody.innerHTML := 'bottom';
  labelBottom.header.innerHTML := '<br>';
  labelBottom.labelbody.style.cssText := 'background-color: yellow; text-align: center; border-color: red; font-size: 22px; font-weight: bold; border-style: solid;';

  ShowComunicazioni;
end;

function TFrmComunicazioni.DateOk: Boolean;
var
  dt1, dt2: TDateTime;
begin
  Result := false;

  if (data1.value = '') or (data2.value = '') or (data1.value > data2.value) then
  begin
    SetLabel(labelTop, msgDateErrate);
    SetLabel(labelBottom, '');
    exit;
  end;

  Result := true;

  dt1 := ScanDateTime('yyyy-MM-dd', data1.value);
  dt2 := ScanDateTime('yyyy-MM-dd', data2.value);
  dt2 := IncDay(dt2);

  // Formato per la query
  dt1str := FormatDateTime('dd.MM.yyyy', dt1);
  dt2str := FormatDateTime('dd.MM.yyyy', dt2);

  whereDate := ' dtsospesofinoa >= ''' + dt1str + ''' and dtsospesofinoa < ''' + dt2str + '''';

  // Formato per eventuale stampa/logica aggiuntiva
  dt1str := FormatDateTime('dd/MM/yyyy', dt1) + ' 00:00:00';
  dt2str := FormatDateTime('dd/MM/yyyy', dt2) + ' 00:00:00';
end;

procedure TFrmComunicazioni.ShowComunicazioni; async;
begin
  if not DateOk then
  begin
    ImpostaVisibilita(visDateErrate);
    exit;
  end;

  ImpostaVisibilita(visCaricamentoInCorso);

  QryComunicazioni.Close;
  QryComunicazioni.SQL.Text := 'select dtsospesofinoa as valfinoa, '
    + ' dsnote as comunicazione, dtdata as datains from vo_comunicazioni where ' + whereDate;
  QryComunicazioni.SQL.Text := QryComunicazioni.SQL.Text + ' order by dtsospesofinoa ';
  await(QryComunicazioni.Open);

  RefreshFiltro;
end;

procedure TFrmComunicazioni.QryVolontariOnFilterRecord(DataSet: TDataSet; var Accept: Boolean);
var
  str: String;
  i: Integer;
begin
  Accept := true;
  str := filtro.value.ToLowerInvariant;

  if str = '' then exit;

  for i := 0 to DataSet.FieldCount - 1 do
  begin
    if DataSet.Fields[i].Visible and
       DataSet.Fields[i].DisplayText.ToLowerInvariant.Contains(str) then
      exit;
  end;

  Accept := false;
end;

procedure TFrmComunicazioni.RefreshFiltro;
begin
  QryComunicazioni.Filtered := filtro.value.Trim <> '';
  QryComunicazioni.First;
  tab1.RenderDataSet(QryComunicazioni);

  if QryComunicazioni.IsEmpty then
    ImpostaVisibilita(visNessunRecord)
  else if QryComunicazioni.RecordCount >= limiteRecord then
    ImpostaVisibilita(visLimiteRecord)
  else
    ImpostaVisibilita(visCiSonoRecord);
end;

procedure TFrmComunicazioni.SetLabel(lbl: TWLabel; value: String);
begin
  lbl.Visible := value <> '';
  lbl.labelbody.innerHTML := value;
end;

procedure TFrmComunicazioni.ImpostaVisibilita(visibilita: TVisibilita);
begin
  SetLabel(labelTop, '');
  SetLabel(labelBottom, '');

  case visibilita of
    visDateErrate: SetLabel(labelTop, msgDateErrate);
    visNessunRecord: SetLabel(labelBottom, msgNessunRecord);
    visLimiteRecord: SetLabel(labelBottom, msgLimiteRecord);
    visCaricamentoInCorso: SetLabel(labelBottom, msgCaricamentoInCorso);
  end;

  filtro.Visible := visibilita <> visDateErrate;
  pnltab1.Visible := visibilita in [visLimiteRecord, visCiSonoRecord];
end;

procedure TFrmComunicazioni.filtro_change;
begin
  RefreshFiltro;
end;

procedure TFrmComunicazioni.filtro_input;
begin
  RefreshFiltro;
end;

procedure TFrmComunicazioni.lblHeader_click; async;
begin
  ShowComunicazioni;
end;

procedure TFrmComunicazioni.data1_change;
begin

  window.localStorage[ClassName+'_data1'] := data1.value;
  ShowComunicazioni;

end;

procedure TFrmComunicazioni.data2_change;
begin

  window.localStorage[ClassName+'_data2'] := data2.value;
  ShowComunicazioni;

end;

initialization
  RegisterWeb(TFrmComunicazioni);

end.
